<template>
    <div class="intelligence-table">
        <h3 class="intelligence-table__title">{{ $t('pages.intelligence.supply_demand.charts.gap_table') }}</h3>
        <div v-if="rows.length" class="intelligence-table__wrapper">
            <table>
                <thead>
                    <tr>
                        <th>{{ $t('pages.intelligence.supply_demand.table.specialty') }}</th>
                        <th>{{ $t('pages.intelligence.supply_demand.table.demand') }}</th>
                        <th>{{ $t('pages.intelligence.supply_demand.table.supply') }}</th>
                        <th>{{ $t('pages.intelligence.supply_demand.table.gap') }}</th>
                        <th>{{ $t('pages.intelligence.supply_demand.table.constrained') }}</th>
                        <th>{{ $t('pages.intelligence.supply_demand.table.share') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in rows" :key="row.specialityId">
                        <td>{{ row.specialityName }}</td>
                        <td>{{ row.demandCount }}</td>
                        <td>{{ row.supplyProviderCount }}</td>
                        <td :class="{ 'is-gap': row.gap > 0 }">{{ row.gap }}</td>
                        <td>{{ row.constrainedDemandCount }}</td>
                        <td>{{ row.demandSharePercent }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p v-else class="intelligence-table__empty">{{ $t('pages.intelligence.supply_demand.empty') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            rows: {
                type: Array,
                default: () => [],
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-table {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-table__title {
        margin: 0 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #111827;
    }

    .intelligence-table__wrapper {
        overflow-x: auto;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
    }

    th,
    td {
        padding: 12px 10px;
        text-align: left;
        border-bottom: 1px solid #e5e7eb;
    }

    th {
        color: #6b7280;
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
    }

    .is-gap {
        color: #b91c1c;
        font-weight: 600;
    }

    .intelligence-table__empty {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }
</style>
